<script setup lang="ts">
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { useDark } from '@vueuse/core'
import { onUnmounted } from 'vue'
import { useOIDCStore } from '@/stores/oidc.store'

/** Dark/light mode state. */
useDark()

// Cleanup OIDC store event listeners on app unmount
const oidcStore = useOIDCStore()
onUnmounted(() => {
  oidcStore.cleanup()
})
</script>

<template>
  <RouterView />
  <VueQueryDevtools />
</template>
